import { buildKey, getLowerCaseValue } from '@yme/utils/common';
export function getKey(value, index) {
    return buildKey(getLowerCaseValue(value), index);
}
export function buildListData({ cards = [], labelLink = '', }) {
    if (!cards) {
        return undefined;
    }
    const finalData = cards.reduce((acc, item) => {
        if (!acc?.length && item) {
            return [
                {
                    ...item,
                    labelLink,
                    countLineVisible: 'initial',
                },
            ];
        }
        return [
            ...acc,
            {
                ...item,
                labelLink,
                countLineVisible: 'initial',
            },
        ];
    }, []);
    return finalData;
}
